import './ChartTextEllipsis.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var ellipsis = _7a468({defaultClassName:'_ix5ox20-3-12-1',variantClassNames:{truncationMode:{start:'_ix5ox21-3-12-1',end:'_ix5ox22-3-12-1',middle:'_ix5ox23-3-12-1'}},defaultVariants:{},compoundVariants:[]});
export var truncationContainer = '_ix5ox24-3-12-1';
export var truncationText = '_ix5ox25-3-12-1';